import React from 'react';

import styles from './CustomCheckbox.module.scss';

const CustomCheckbox = ({text, id, isChecked, handleCheckboxChange, borderColor}) => {
    return (
        <div className={styles.wrapper}>
            <input
                style={{borderColor}}
                className={styles.input}
                type="checkbox"
                id={id}
                checked={isChecked}
                onChange={handleCheckboxChange && handleCheckboxChange}
            />
            <label
                className={styles.label}
                htmlFor={id}
            >{text}</label>
        </div>
    );
};

export default CustomCheckbox;
